import type { JSX } from 'react';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { useLicense } from '@feathr/extender/hooks';
import { useGoogleAdsPermissions } from '@feathr/extender/hooks';
import { useAccount } from '@feathr/extender/state';

import CampaignsPage from '../EventsPage/CampaignsPage';
import RedirectTo404 from './RedirectTo404';
import RouteWithPermissions from './RouteWithPermissions';

function MarketingRoutes(): JSX.Element {
  const { isPlatformLite } = useAccount();
  const { hasMonetization, googleAdsSmart } = useLicense();
  // Google Ads is still flagged, so we need to check if the user has access to it.
  const showGoogleAds = useGoogleAdsPermissions();

  return (
    <Switch>
      <Redirect exact={true} from={'/:accountId/marketing'} to={'/:accountId/marketing/all'} />
      <Route path={'/:accountId/marketing/all'}>
        <CampaignsPage campaignGroup={'all'} />
      </Route>
      <Route path={'/:accountId/marketing/ads'}>
        <CampaignsPage campaignGroup={'ads'} />
      </Route>
      <Route path={'/:accountId/marketing/email'}>
        <CampaignsPage campaignGroup={'email'} />
      </Route>
      <RouteWithPermissions
        condition={googleAdsSmart && showGoogleAds}
        path={'/:accountId/marketing/google-ads'}
      >
        <CampaignsPage campaignGroup={'google-ads'} />
      </RouteWithPermissions>
      <RouteWithPermissions condition={hasMonetization} path={'/:accountId/marketing/monetization'}>
        <CampaignsPage campaignGroup={'monetization'} />
      </RouteWithPermissions>
      <RouteWithPermissions condition={!isPlatformLite} path={'/:accountId/marketing/other'}>
        <CampaignsPage campaignGroup={'other'} />
      </RouteWithPermissions>
      <RedirectTo404 />
    </Switch>
  );
}

export default MarketingRoutes;
